// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__flZCw","label":"IconButton_label__Q2tKr"};